<template>
  <div class="page-login">
    <weui-group>
      <weui-input label="手机号码" v-model="phone" type="tel" placeholder="填写手机号码" />
      <weui-input label="图形验证码" v-model="captcha" placeholder="输入图形验证码" :show-vcode="true">
        <img slot="image" class="weui-vcode-img" :src="captchaImg" @click="fetchCaptcha">
      </weui-input>
      <weui-input label="验证码" v-model="sms_code" type="number" placeholder="输入验证码" :show-vcode="true">
        <vcode-button slot="button" :phone="phone" :captcha="captcha" />
      </weui-input>
    </weui-group>
    <weui-button-area>
      <weui-button class="login-btn" type="primary" @click="submit">提交</weui-button>
    </weui-button-area>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { WeuiGroup, WeuiInput, WeuiButton, WeuiButtonArea } from '@/components/weui';
import VcodeButton from '@/components/auth/VcodeButton';

import { FETCH_CAPTCHA } from '@/store/auth/types';
import { PATCH_COACH_PHONE } from '@/store/coach/types';
import { ROUTE_COACH } from '@/router/names';

const { mapState: mapAuthState, mapActions: mapAuthActions } = createNamespacedHelpers('auth');
const { mapActions: mapCoachActions } = createNamespacedHelpers('coach');

export default {
    data() {
        return {
            phone: '',
            captcha: '',
            sms_code: '',
        };
    },
    computed: {
        ...mapAuthState([
            'captchaImg',
        ]),
    },
    mounted() {
        this.fetchCaptcha();
    },
    methods: {
        ...mapAuthActions({
            fetchCaptcha: FETCH_CAPTCHA,
        }),
        ...mapCoachActions({
            patchPhone: PATCH_COACH_PHONE,
        }),
        submit() {
            this.patchPhone({
                bind_phone: this.phone,
                bind_sms_code: this.sms_code,
            }).then(() => {
                this.$router.push({
                    name: ROUTE_COACH,
                });
            });
        },
    },
    components: {
        WeuiGroup,
        WeuiInput,
        WeuiButton,
        WeuiButtonArea,
        VcodeButton,
    },
};
</script>

<style scoped>
.weui-vcode-img {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/containers/coach/Phone.vue